module.exports = __webpack_public_path__ + "img/emp_ch_karl_0.f1973a2c.png";